import { call } from "redux-saga/effects";
import { createSaga } from "../../../utils/saga";
import { updateProfileAccess } from "../client";
import slice from "../slice";
import type { PayloadAction } from "../../../utils/action";
import type { Profile } from "@superblocksteam/shared";

interface UpdateProfileAccessPayload {
  orgId: string;
  profileId: string;
  accessUpdate: {
    allowedInEditor?: boolean;
    allowedInPreview?: boolean;
    allowedInDeployed?: boolean;
  };
}

interface UpdateProfileAccessResponse {
  orgId: string;
  profileId: string;
  updated: Profile;
}

function* updateProfileAccessInternal({
  orgId,
  profileId,
  accessUpdate,
}: UpdateProfileAccessPayload) {
  const profile: Profile = yield call(
    updateProfileAccess,
    orgId,
    profileId,
    accessUpdate,
  );
  return {
    orgId,
    profileId,
    updated: profile,
  } as UpdateProfileAccessResponse;
}

export const updateProfileAccessSaga = createSaga(
  updateProfileAccessInternal,
  "updateProfileAccessSaga",
  { sliceName: "organizations" },
);

slice.saga(updateProfileAccessSaga, {
  start(state, payload: PayloadAction<UpdateProfileAccessPayload>) {
    state.loading[payload.payload.orgId] = true;
    delete state.errors[payload.payload.orgId];
  },
  success(state, { payload }) {
    state.entities[payload.orgId] = state.entities[payload.orgId] ?? {};
    const existingProfiles = state.entities[payload.orgId].profiles;
    state.entities[payload.orgId].profiles = existingProfiles?.map(
      (profile) => {
        if (profile.id === payload.profileId) {
          return {
            ...profile,
            ...payload.updated,
          };
        }
        return profile;
      },
    );
    delete state.loading[payload.orgId];
  },
  error(state, { payload, meta }) {
    state.errors[meta.args.orgId] = { error: payload };
    delete state.loading[meta.args.orgId];
  },
});
